<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="col-md-12">
                <div v-bind:id="identifier"></div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {

        data: function () {
            return {
                chart: null,
                mounted: false,
                storage: storage,
            }
        },

        watch: {
            series: function () {

                if (!this.mounted) {
                    return;
                }

                var text = this.title;

                var id = this.identifier;

                var yAxis = this.yAxis.map(function (title) {
                    return {
                        title: {
                            text: title
                        }
                    };
                });

                const json = {
                    chart: {
                        renderTo: id
                    },
                    title: {
                        text: text,
                    },
                    series: this.series,
                    yAxis: yAxis,
                    legend: {
                        itemStyle: {
                            width: 550,
                        },
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false,
                            }
                        }
                    },
                    credits: {
                        enabled: false,
                    },
                };

                this.chart = null;
                this.chart = new Highcharts.Chart(json);
            }
        },

        computed: {
            title: function () {
                return this.storage.title;
            },

            pattern: function () {
                return this.storage.pattern;
            },

            identifier: function () {
                return "unique123";
            },
            yAxis: function () {
                return ["Values"];
            },
            series: function () {
                return [{
                    name: this.title,
                    data: this.pattern.split("\n").map(function (item) {
                        const foo = item.split(",");
                        return [Date.parse(foo[0]), parseFloat(foo[1])];
                    }).sort(function (a, b) {
                        return a[0] - b[0]
                    }),
                    yAxis: 0,
                }];
            },
        },

        mounted: function () {
            this.mounted = true;
        },

    }

</script>